import SectionLabel from "@/components/SectionLabel";
import {
  Users,
  Sparkles,
  BookOpenText,
  HeartHandshake,
  HandHeart,
  Leaf,
} from "lucide-react";

const ministries = [
  {
    icon: Users,
    title: "GKK Formation",
    body: "Strengthening basic ecclesial communities through leadership, Bible service, pastoral visitation, and active participation.",
  },
  {
    icon: Sparkles,
    title: "Youth Ministry",
    body: "Forming young people to become joyful disciples, responsible leaders, and creative witnesses of the Gospel.",
  },
  {
    icon: BookOpenText,
    title: "Lay Liturgical Ministries",
    body: "Readers, lay cooperators, choir, altar servers — serving the worship life of the parish with reverence.",
  },
  {
    icon: HeartHandshake,
    title: "Family & Life",
    body: "Accompanying families through formation, pastoral care, and support for Christian family life.",
  },
  {
    icon: HandHeart,
    title: "Social Action",
    body: "Responding to the poor, fisherfolks, women, children, and families affected by calamities and need.",
  },
  {
    icon: Leaf,
    title: "Ecology Ministry",
    body: "Living the spirit of Laudato Si’ through care for creation and parish environmental action.",
  },
];

export default function Ministries() {
  return (
    <section id="ministries" className="py-24 md:py-36 bg-parchment-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel
          kicker="Parish Life"
          title="Ministries & Formation"
          intro="Our ministries help the parish become a living community of prayer, service, formation, and mission."
        />

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ministries.map(({ icon: Icon, title, body }) => (
            <article
              key={title}
              className="group relative bg-parchment-50 border border-parchment-400 p-8 hover:border-terracotta/60 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="flex items-start justify-between mb-6">
                <Icon className="text-terracotta" size={28} strokeWidth={1.4} />
                <span className="text-[10px] uppercase tracking-[0.25em] text-sage-dark font-sans">
                  Servire
                </span>
              </div>
              <h3 className="font-serif text-2xl text-cocoa-900 mb-3 leading-tight">
                {title}
              </h3>
              <p className="font-sans text-cocoa-800 leading-relaxed font-light text-[15px]">
                {body}
              </p>
              <div className="mt-6 h-px w-8 bg-sage group-hover:w-16 transition-all duration-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
